import React, { useState } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import { StudentNavbar, ModuleOverview, SubjectSideNavigation } from '../../../../../components';
import bio from '../../../../../assets/biology.avif';

const PlantAnatomyAndPhysiology = () => {
  const subjectName = "Biology";
  const examType = "BGCSE";

  // Index should always equal the module_number
  const [selectedModule, setSelectedModule] = useState({
    index: 4,
    title: "Plant Anatomy and Physiology",
  });

  const [showModuleMenu, setShowModuleMenu] = useState(false);

  const handleModuleSelect = (module) => {
    setSelectedModule(module);
    setShowModuleMenu(false);
  };

  return (
    <div>
      <StudentNavbar />

      <div className="bg-white w-full">
        {/* Responsive grid: 1 col on mobile/tablet, 5 cols on lg+ */}
        <div className="grid grid-cols-1 lg:grid-cols-5">
          {/* Side Navigation: hidden on small, visible on lg+ */}
          <div className="hidden lg:block lg:col-span-1 text-sm">
            <SubjectSideNavigation
              selectedModuleIndex={selectedModule.index}
              setSelectedModule={setSelectedModule}
              subjectName={subjectName}
              img={bio}
            />
          </div>

          {/* Main Content */}
          <div className="col-span-1 lg:col-span-4 bg-[#f0f0f0] min-h-screen px-3 sm:px-5 py-3 sm:py-5 lg:h-[calc(100vh-100px)] overflow-y-auto">
            {/* Mobile Module Dropdown Button */}
            <div className="lg:hidden mb-4">
              <button
                onClick={() => setShowModuleMenu(!showModuleMenu)}
                className="w-full bg-white rounded-lg shadow-sm px-4 py-3 flex items-center justify-between text-gray-700 hover:bg-gray-50 transition"
              >
                <div className="flex items-center gap-3">
                  <img
                    src={bio}
                    alt={subjectName}
                    className="h-8 w-8 rounded object-cover"
                  />
                  <div className="flex flex-col items-start leading-tight">
                    <span className="font-semibold">{subjectName} Modules</span>
                    <span className="text-xs text-gray-500">
                      Currently: {selectedModule.title}
                    </span>
                  </div>
                </div>

                {showModuleMenu ? (
                  <RiCloseLine size={24} className="text-gray-600" />
                ) : (
                  <RiMenu3Line size={24} className="text-gray-600" />
                )}
              </button>

              {/* Dropdown Menu */}
              {showModuleMenu && (
                <div className="mt-2 bg-white rounded-lg shadow-lg overflow-hidden animate-scale-down">
                  <SubjectSideNavigation
                    selectedModuleIndex={selectedModule.index}
                    setSelectedModule={handleModuleSelect}
                    subjectName={subjectName}
                    img={bio}
                  />
                </div>
              )}
            </div>

            <ModuleOverview
              module_number={selectedModule.index}
              module_name={selectedModule.title}
              module_description={`
                This module explores how plants are built and how they function. You’ll learn
                about plant tissues and organs, transport in xylem and phloem, and how plants
                control water loss through stomata. You’ll also study photosynthesis and factors
                that affect it, along with plant reproduction and growth—connecting plant
                structure to survival in different environments.
              `}
              subject_name={subjectName}
              exam_type={examType}
            />
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scale-down {
          0% {
            transform: scaleY(0);
            opacity: 0;
            transform-origin: top;
          }
          100% {
            transform: scaleY(1);
            opacity: 1;
            transform-origin: top;
          }
        }
        .animate-scale-down {
          animation: scale-down 0.2s ease-out both;
        }
      `}</style>
    </div>
  );
};

export default PlantAnatomyAndPhysiology;
